export default __webpack_public_path__ + "static/media/uk-flag-round-circle-icon.03cb69cc.svg";